import { P1Regular as P1RegularStyle } from 'theme/typography';
import { Text, TextProps } from '@mantine/core';
import mergeTextSx from 'components/typography/merge-text-sx';

/**
 * Applies the P1Regular typography style.
 */
export default function P1Regular({ sx, ...props }: TextProps) {
  return <Text {...props} sx={mergeTextSx(P1RegularStyle, sx)} />;
}
